<template>
  <div>
    <ShowBookingPaymentStep />
  </div>
</template>

<script>
  import ShowBookingPaymentStep from '@/components/Book/show/ShowBookingPaymentStep'

  export default {
    name: 'ShowBookingPayment',

    components: {
      ShowBookingPaymentStep,
    },

    computed: {
      steps() {
        return this.$store.getters['showBooking/enabledSteps']
      },
    },

    methods: {
      determineStepNumber() {
        let step = this.steps.findIndex(step => step.name == 'payment')

        if (step === -1) {
          return this.$router.push({ name: this.steps[0].route })
        }

        this.$store.commit('showBooking/setCurrentStep', step + 1)
      }
    },

    mounted() {
      this.determineStepNumber()
    }
  }
</script>
